'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-79db6cc8.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var search = require('./search-c27fa133.js');
require('./pill-89b3b361.js');
var formField = require('./form-field-8601b6d9.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
var messages = require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
var component$4 = require('./component-39a54733.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var popover = require('./popover-09eb9e01.js');
var emptyState = require('./empty-state-4520e4db.js');
var menuItem = require('./menu-item-dfcda6d2.js');

var KeyboardKeysEnum;
(function (KeyboardKeysEnum) {
    KeyboardKeysEnum["ARROW_DOWN"] = "ArrowDown";
    KeyboardKeysEnum["ARROW_UP"] = "ArrowUp";
    KeyboardKeysEnum["BACKSPACE"] = "Backspace";
    KeyboardKeysEnum["ENTER"] = "Enter";
    KeyboardKeysEnum["TAB"] = "Tab";
})(KeyboardKeysEnum || (KeyboardKeysEnum = {}));
var useChipDropdown = function (_a) {
    var searchValue = _a.searchValue, onClose = _a.onClose, addData = _a.addData, removeData = _a.removeData, searchData = _a.searchData, selectedData = _a.selectedData, openMenuByClick = _a.openMenuByClick;
    var containerRef = React.useRef(null);
    var option = React.useRef(null);
    var _b = useBooleanState_hook.useBooleanState(), isFocused = _b.value, setFocused = _b.setTrue, setUnFocused = _b.setFalse;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var initialDataLength = React.useMemo(function () { var _a, _b; return ((_a = searchData === null || searchData === void 0 ? void 0 : searchData.length) !== null && _a !== void 0 ? _a : 0) + ((_b = selectedData === null || selectedData === void 0 ? void 0 : selectedData.length) !== null && _b !== void 0 ? _b : 0); }, []);
    var isAllOptionsSelected = (selectedData === null || selectedData === void 0 ? void 0 : selectedData.length) === initialDataLength;
    var hasSearchValue = searchValue !== '';
    var noSearchData = hasSearchValue && !(searchData === null || searchData === void 0 ? void 0 : searchData.length);
    var isMenuOpened = openMenuByClick
        ? isFocused && (((searchData === null || searchData === void 0 ? void 0 : searchData.length) > 0) || isAllOptionsSelected || noSearchData)
        : hasSearchValue;
    React.useEffect(function () {
        option.current = null;
    }, [searchValue]);
    var handleClose = React.useCallback(function () {
        option.current = null;
        setUnFocused();
        onClose();
    }, [onClose, setUnFocused]);
    var removeFocus = React.useCallback(function (currOption) {
        var _a;
        var element = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.childNodes[currOption];
        if (element) {
            element.classList.remove('focused');
        }
    }, [containerRef]);
    var addFocus = React.useCallback(function () {
        var _a, _b, _c;
        var element = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.childNodes) === null || _b === void 0 ? void 0 : _b[(_c = option.current) !== null && _c !== void 0 ? _c : 0];
        if (element) {
            element.classList.add('focused');
        }
    }, [containerRef]);
    var onKeyOptionNavigation = React.useCallback(function (event) {
        var length = searchData.length - 1;
        if (event.key === KeyboardKeysEnum.ARROW_DOWN) {
            var cursor = option.current === null ? 0 : option.current + 1;
            option.current = cursor > length ? length : cursor;
            if (option.current > 0) {
                removeFocus(option.current - 1);
            }
            addFocus();
        }
        if (event.key === KeyboardKeysEnum.ARROW_UP) {
            var cursor = option.current === null ? length : (option === null || option === void 0 ? void 0 : option.current) - 1;
            option.current = cursor < 0 ? 0 : cursor;
            if (option.current < length) {
                removeFocus(option.current + 1);
            }
            addFocus();
        }
        if (event.key === KeyboardKeysEnum.ENTER && option.current !== null) {
            addData(searchData[option.current]);
            option.current = null;
        }
    }, [addData, addFocus, removeFocus, searchData]);
    var onKeyDown = React.useCallback(function (event) {
        if (event.key === KeyboardKeysEnum.TAB) {
            handleClose();
        }
        if (isMenuOpened && searchData.length) {
            onKeyOptionNavigation(event);
        }
        if (!hasSearchValue && event.key === KeyboardKeysEnum.BACKSPACE && removeData) {
            removeData(selectedData[(selectedData === null || selectedData === void 0 ? void 0 : selectedData.length) - 1]);
        }
    }, [handleClose, hasSearchValue, isMenuOpened, onKeyOptionNavigation, removeData, searchData.length, selectedData]);
    var onBlur = React.useCallback(function () {
        if (openMenuByClick) {
            return;
        }
        setUnFocused();
    }, [openMenuByClick, setUnFocused]);
    return {
        containerRef: containerRef,
        handleClose: handleClose,
        onKeyDown: onKeyDown,
        onFocus: setFocused,
        onBlur: onBlur,
        isFocused: isFocused,
        isMenuOpened: isMenuOpened,
        isAllOptionsSelected: isAllOptionsSelected,
    };
};

var StyledPopover = styled__default(popover.Popover)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  box-shadow: ", ";\n  background-color: ", ";\n  z-index: 1;\n  border-radius: 4px;\n  padding: 12px 0;\n  height: ", ";\n  overflow: auto;\n"], ["\n  box-shadow: ", ";\n  background-color: ", ";\n  z-index: 1;\n  border-radius: 4px;\n  padding: 12px 0;\n  height: ", ";\n  overflow: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.shadows.depth_1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var optionsLength = _a.optionsLength;
    return (optionsLength > 7 ? '354px' : 'auto');
});
var StyledFormField = styled__default(formField.FormField)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  min-width: 792px;\n\n  .input.field {\n    padding-left: 8px;\n\n    &:first-child {\n      padding-left: 0;\n    }\n  }\n"], ["\n  min-width: 792px;\n\n  .input.field {\n    padding-left: 8px;\n\n    &:first-child {\n      padding-left: 0;\n    }\n  }\n"])));
var StyledEmptyState = styled__default(emptyState.EmptyState)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  svg, i {\n    margin-bottom: 4px;\n  }\n\n  & > p {\n    margin: 0;\n    & + p {\n      margin: 4px 0 0;\n    }\n  }\n"], ["\n  svg, i {\n    margin-bottom: 4px;\n  }\n\n  & > p {\n    margin: 0;\n    & + p {\n      margin: 4px 0 0;\n    }\n  }\n"])));
var StyledSpinnerContainer = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  text-align: center;\n  width: 100%;\n"], ["\n  text-align: center;\n  width: 100%;\n"])));
var defaultEmptyStateProps = {
    title: 'No results found',
    description: ['Try searching for a different one'],
    Icon: search.Search,
};
var ChipDropdown = function (_a) {
    var _b, _c, _d;
    var title = _a.title, _e = _a.required, required = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, placeholder = _a.placeholder, onSearch = _a.onSearch, errorText = _a.errorText, hint = _a.hint, _g = _a.searchValue, searchValue = _g === void 0 ? '' : _g, searchData = _a.searchData, _h = _a.selectedData, selectedData = _h === void 0 ? [] : _h, emptyStateProps = _a.emptyStateProps, addData = _a.addData, _j = _a.isLoading, isLoading = _j === void 0 ? false : _j, removeData = _a.removeData, onClose = _a.onClose, readOnly = _a.readOnly, _k = _a.openMenuByClick, openMenuByClick = _k === void 0 ? false : _k, _l = _a.allOptionsSelectedText, allOptionsSelectedText = _l === void 0 ? 'All possible options have been selected' : _l, rest = tslib_es6.__rest(_a, ["title", "required", "disabled", "placeholder", "onSearch", "errorText", "hint", "searchValue", "searchData", "selectedData", "emptyStateProps", "addData", "isLoading", "removeData", "onClose", "readOnly", "openMenuByClick", "allOptionsSelectedText"]);
    var _m = useChipDropdown({
        searchValue: searchValue, onClose: onClose, addData: addData, removeData: removeData, searchData: searchData, selectedData: selectedData, openMenuByClick: openMenuByClick,
    }), containerRef = _m.containerRef, handleClose = _m.handleClose, onKeyDown = _m.onKeyDown, isFocused = _m.isFocused, onFocus = _m.onFocus, onBlur = _m.onBlur, isMenuOpened = _m.isMenuOpened, isAllOptionsSelected = _m.isAllOptionsSelected;
    var ChipDropdownContent = (searchData.length > 0 ? (React__default.createElement(React__default.Fragment, null, searchData.map(function (c) { return (React__default.createElement(menuItem.MenuItem, { key: c.value, label: c.label, value: c.value, storedValue: c, onChange: addData })); }))) : (React__default.createElement(StyledEmptyState, tslib_es6.__assign({}, (emptyStateProps && emptyStateProps), { dataTestId: "chip-empty-state", title: isAllOptionsSelected
            ? allOptionsSelectedText : ((_b = emptyStateProps === null || emptyStateProps === void 0 ? void 0 : emptyStateProps.title) !== null && _b !== void 0 ? _b : defaultEmptyStateProps.title), description: isAllOptionsSelected
            ? undefined : ((_c = emptyStateProps === null || emptyStateProps === void 0 ? void 0 : emptyStateProps.description) !== null && _c !== void 0 ? _c : defaultEmptyStateProps.description), Icon: isAllOptionsSelected ? undefined : ((_d = emptyStateProps === null || emptyStateProps === void 0 ? void 0 : emptyStateProps.Icon) !== null && _d !== void 0 ? _d : defaultEmptyStateProps.Icon), showIcon: !isAllOptionsSelected }))));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledPopover, tslib_es6.__assign({ bodyRef: containerRef, open: isMenuOpened, onClose: handleClose, disabled: disabled, buttonComponent: (React__default.createElement(StyledFormField, { required: required, disabled: disabled, label: title, value: searchValue, onChange: onSearch, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, placeholder: placeholder, chips: selectedData, onChipRemove: removeData, isErrored: !!errorText, variant: "chip-dropdown", readOnly: readOnly, isFocused: isFocused })), wrapperClassName: "chip-dropdown-wrapper", position: "bottom", alignment: "stretch", optionsLength: searchData === null || searchData === void 0 ? void 0 : searchData.length, checkItemClass: openMenuByClick }, rest), isLoading ? (React__default.createElement(StyledSpinnerContainer, null,
            React__default.createElement(component$4.Spinner, { color: hqoTheme.colors.palette.modifiedMalibuBlue, size: "2em" }))) : ChipDropdownContent),
        (errorText || hint) && (React__default.createElement(messages.Messages, { errorText: errorText, hint: hint, dataCy: "chip", dataTestId: "chip" }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.ChipDropdown = ChipDropdown;
exports.defaultEmptyStateProps = defaultEmptyStateProps;
